import { useContext, useEffect, useState } from "react";
import { Button, Tooltip } from "@mui/material";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import { EditContext } from "./EditProvider";
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function TableInsert(props) {
    var _props$shortcut;
    const [showCreate, setShowCreate] = useState(false);
    const { hasPopout } = useContext(EditContext);
    const key = ((_props$shortcut = props.shortcut) === null || _props$shortcut === void 0 ? void 0 : _props$shortcut.key) || "+";
    useEffect(() => {
        if (hasPopout)
            return;
        const listener = e => {
            const ctrl = e.ctrlKey || e.metaKey;
            let shiftOk = true;
            let keyOk = e.key === key; // keypress doesn't give resultant char when ctrl is pressed
            if (key === "+") {
                shiftOk = e.shiftKey;
                keyOk = e.key === "=";
            }
            if (ctrl && shiftOk && keyOk) {
                e.preventDefault();
                setShowCreate(true);
            }
        };
        document.addEventListener("keypress", listener);
        return () => document.removeEventListener("keypress", listener);
    }, [hasPopout, key]);
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsxs("div", { style: Object.assign({ position: "absolute", bottom: 40 }, props.alignX === "left" ? { left: 8 } : { right: 8 }), children: [/*#__PURE__*/ _jsx(Tooltip, { title: /*#__PURE__*/ _jsxs(_Fragment, { children: ["Shortcut: ctrl + '", key, "'"] }), children: /*#__PURE__*/ _jsx(Button, { variant: "contained", startIcon: /*#__PURE__*/ _jsx(AddCircleOutline, {}), color: "primary", onClick: () => setShowCreate(true), children: props.buttonText || "New" }) }), props.options ? props.options({}) : null] }), showCreate && props.modal(() => setShowCreate(false))] });
}
